import App from '../client/pages/app'
import SearchPage from '../client/pages/search/searchPage'
import NotFoundPage from '../client/pages/notFoundPage'
import LandingPage from '../client/pages/landing/landingPage'

import createAppContainer from '../client/containers/appContainer'
import createSearchPageContainer from '../client/containers/searchPageContainer'
import createNotFoundContainer from '../client/containers/notFoundContainer'
import createLandingPageContainer from '../client/containers/landingPageContainer'

export default [
  {
    path: '/',
    component: createAppContainer(App),
    routes: [
      {
        path: '/',
        exact: true,
        component: createSearchPageContainer(SearchPage)
      },
      {
        path: '/category/*',
        component: createSearchPageContainer(SearchPage)
      },
      {
        path: '/tags/:tags',
        component: createSearchPageContainer(SearchPage)
      },
      {
        path: '/attributes/:key/:value',
        component: createSearchPageContainer(SearchPage)
      },
      {
        path: '/search',
        component: createSearchPageContainer(SearchPage)
      },
      {
        path: '/free/:page',
        component: createLandingPageContainer(LandingPage)
      },
      {
        path: '/*',
        component: createNotFoundContainer(NotFoundPage)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./common/routes.js